module.exports = __webpack_public_path__ + "img/gran_oro-2021.21f90484.png";